import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DiagnosticQuestionsComponent } from "./diagnostic-questions.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { AngularToastifyModule } from "angular-toastify";
import { SharedModule } from "src/app/shared/components/shared.module";
import { CustomPipesModule } from "src/app/shared/pipes/custom-pipes.module";
import { MatPaginatorModule } from "@angular/material/paginator";
import { QuestionEditorComponent } from "./question-editor/question-editor.component";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatStepperModule } from "@angular/material/stepper";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		AngularToastifyModule,
		FormsModule,
		MatButtonModule,
		MatCardModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatGridListModule,
		MatTabsModule,
		MatIconModule,
		MatInputModule,
		MatListModule,
		MatToolbarModule,
		MatTooltipModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		MatSortModule,
		MatTableModule,
		MatPaginatorModule,
		ReactiveFormsModule,
		CustomPipesModule,
		SharedModule,
		ClipboardModule,
		MatChipsModule,
		MatDialogModule,
		MatStepperModule,
		MatSlideToggleModule,
	],
	declarations: [
		DiagnosticQuestionsComponent,
		QuestionEditorComponent,
	],
	exports: [
		DiagnosticQuestionsComponent,
		QuestionEditorComponent,
	],
})
export class DiagnosticQuestionsModule {}
